import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { CmsNavigationComponent } from '@spartacus/core';
import { CmsComponentData, NavigationNode, NavigationService } from '@spartacus/storefront';
import { Observable } from 'rxjs';

@Component({
  selector: 'ui-sitemap',
  templateUrl: './sitemap.component.html',
  styleUrls: ['./sitemap.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SitemapComponent implements OnInit {
  node$: Observable<NavigationNode>;

  constructor(
    private navigationService: NavigationService,
    private component: CmsComponentData<CmsNavigationComponent>,
  ) {}

  ngOnInit(): void {
    this.node$ = this.navigationService.getNavigationNode(this.component.data$);
  }
}
